import { createContext } from 'react';

const RowContext = createContext({});
var RowContext$1 = RowContext;

export { RowContext$1 as default };
